module.exports = __webpack_public_path__ + "ky.b148cc3d936efc1fd999.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ky.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ky.svg
// module chunks = styles